<nb-card class="model1-full">
    <nb-card-header>
      <div>
        Edit Profile
      </div>
      <button (click)="close()" size="small" [disabled]="disabled" nbButton ghost status="basic"><nb-icon icon="close-outline"></nb-icon></button>
    </nb-card-header>
    <nb-card-body>
        <!-- <nb-list>
          <nb-list-item>
            <div class="row">
              <div class="col-xxl-12 col-xl-12 col-xl-12">
                  <div style="font-weight: bold;">
                    Title
                  </div>
              </div>
            </div>
          </nb-list-item>
        </nb-list> -->
        <div class="row">
          <div class="col-xxl-12 col-xl-12 col-md-12 col-sm-12 align">
            <ngx-avatar [style]="customStyle" size="100" [name]="fullName" ></ngx-avatar>
          </div>
        </div>
        <div class="pt-2 pb-2">
          <div class="row">
            <div class="col-xxl-12 col-xl-12 col-md-12 col-sm-12 align">
                <h4 style="font-weight: bold;">
                  {{fullName}}
                </h4>
            </div>
          </div>
          <div>
            <input type="text" status="primary" [value]="text" nbInput fullWidth shape="round" placeholder="Introduction...">
          </div>
          <div class="row pt-4">
            <div class="col-xxl-6 col-xl-6 col-md-6 col-sm-6 alignStart">
              <button nbButton size="small" [disabled]="disabled" status="info" (click)="editIntroduction()">Edit Introduction</button>
            </div>
          </div>
        </div>
    </nb-card-body>
</nb-card>
